<div
	*ngIf="
		(recommendedCarriersStore.numberOfLanes$ | async) > 0 &&
		!(recommendedCarriersStore.loadingLanesList$ | async)
	"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<app-pannel-wrapper
		#pannelWrapperComponent
		(loadMoreProjects)="getAllProjects()"
		(openLaneDetails)="openFullProfile($event)"
		(reloadProjectsList)="reloadProjectsList()"
		(updateSelectedcarrierIds)="updateSelectedcarrierIds.emit($event)"
		[IS_FEEDBACK_ENABLED]="accountSettings.IS_FEEDBACK_ENABLED"
		[accountCarrierLanes]="recommendedCarriersStore.recommendedAccountCarrierLanes$ | async"
		[allProjectsList]="allProjectsList"
		[capacitySearchResults]="recommendedCarriersStore.capacitySearchResults$ | async"
		[carrierAllProjectsMap]="recommendedCarriersStore.recommendedCarrierAllProjectsMap$ | async"
		[carrierProjectMap]="carrierProjectMap"
		[carriersProjectsList]="carriersProjectsList"
		[isLoadingAccountCarrierLanes]="recommendedCarriersStore.loadingLanesList$ | async"
		[isLoadingProjectsList]="isLoadingProjectsList"
		[isMultiselectEnabled]="true"
		[lanePricing]="null"
		[notesCountMap]="notesCountMap"
		[projectsNextPage]="projectsNextPage"
		[searchTruckForm]="searchFormData"
		[showFilter]="false"
		[totalNumberOfProjects]="totalNumberOfProjects"
		[truckLaneSearchId]="recommendedCarriersStore.truckLaneSearchId$ | async"
		[truckSearchResult]="recommendedCarriersStore.truckSearchResult$ | async"
		[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
		[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
		[usersList]="usersList"
		[showDragCarrierText]="true"
		[showTotalCount]="false"
		dragCarrierText="Shift + Click to multi-select"
		fxFlex="100"
	>
	</app-pannel-wrapper>
</div>

<div
	*ngIf="
		!(recommendedCarriersStore.loadingLanesList$ | async) &&
		(recommendedCarriersStore.capacitySearchResults$ | async)?.length == 0
	"
	class="m-t-1"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-card class="m-t-1 m-b-1 padding-0-5" fxFlex fxLayoutAlign="center center">
		No new carriers found.
	</mat-card>
</div>
